import { Text } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useStores } from '../../../common/hooks';
import { WinnerContact } from '../../../models';
import { QuestionnaireContactValidation } from '../../../models/schemas/questionnaire-wizard-validation.schema';
import { ValidationState } from '../../../shared/validation';
import { CommonLabelAndValueList, ValidationMessageList } from '../../shared-components';
import { FlexBox } from '../../shared-components/flex-box';
import { FormInput } from '../../shared-components/form/FormInput';

interface WinnerDetailsContactInformationProps {
  winnerContact: WinnerContact;
  isEditMode: boolean;
  winnerContactValidation: ValidationState<QuestionnaireContactValidation>;
}

const WinnerDetailsContactInformationImpl: React.FC<WinnerDetailsContactInformationProps> = (props) => {
  const {
    winnerContact,
    isEditMode,
    winnerContactValidation,
  } = props;

  const {
    winnersAndFinalistsPageUiStore,
  } = useStores();

  return (
    <FlexBox
      isFullWidth
      direction='column'
      className='winner-finalists-details__summary'
    >
      <Text
        weight='semibold'
        size={400}
      >
        Contact Information
      </Text>
      <FlexBox
        isFullWidth
        className='summary-list'
      >
        <CommonLabelAndValueList
          label='CEO name:'
          labelId='ceo-name'
          childrenFallback={winnerContact.contactName}
        >
          {
            isEditMode &&
            <FormInput
              validationMessage={
                winnerContactValidation.fieldErrors.contactName?.length
                  ? (
                    <ValidationMessageList
                      messages={winnerContactValidation.fieldErrors.contactName}
                    />
                  )
                  : undefined
              }
              onChange={(contactName) => winnersAndFinalistsPageUiStore.setWinnerContactField(
                winnerContact,
                {
                  key: 'contactName',
                  value: contactName,
                },
              )}
              inputProps={{
                'aria-labelledby': 'ceo-name',
                value: winnerContact.contactName ?? '',
                maxLength: 100,
              }}
            />
          }
        </CommonLabelAndValueList>
        <CommonLabelAndValueList
          label='Company name:'
          labelId='company-name'
          childrenFallback={winnerContact.companyName}
        >
          {
            isEditMode &&
            <FormInput
              validationMessage={
                winnerContactValidation.fieldErrors.companyName?.length
                  ? (
                    <ValidationMessageList
                      messages={winnerContactValidation.fieldErrors.companyName}
                    />
                  )
                  : undefined
              }
              onChange={(companyName) => winnersAndFinalistsPageUiStore.setWinnerContactField(
                winnerContact,
                {
                  key: 'companyName',
                  value: companyName,
                },
              )}
              inputProps={{
                'aria-labelledby': 'company-name',
                value: winnerContact.companyName ?? '',
                maxLength: 100,
              }}
            />
          }
        </CommonLabelAndValueList>
      </FlexBox>
      <FlexBox
        isFullWidth
        className='summary-list'
      >
        <CommonLabelAndValueList
          label='Company website:'
          labelId='company-website'
          childrenFallback={winnerContact.companyWebsite}
        >
          {
            isEditMode &&
            <FormInput
              validationMessage={
                winnerContactValidation.fieldErrors.companyWebsite?.length
                  ? (
                    <ValidationMessageList
                      messages={winnerContactValidation.fieldErrors.companyWebsite}
                    />
                  )
                  : undefined
              }
              onChange={(companyWebsite) => winnersAndFinalistsPageUiStore.setWinnerContactField(
                winnerContact,
                {
                  key: 'companyWebsite',
                  value: companyWebsite,
                },
              )}
              inputProps={{
                'aria-labelledby': 'company-website',
                value: winnerContact.companyWebsite ?? '',
                maxLength: 100,
              }}
            />
          }
        </CommonLabelAndValueList>
      </FlexBox>
    </FlexBox>
  );
}

export const WinnerDetailsContactInformation = observer(WinnerDetailsContactInformationImpl);
